/* eslint-disable @typescript-eslint/no-explicit-any */
import { gql } from '@apollo/client';

export const generateOnboardingReport = gql`
  mutation GenerateOnboardingReport($input: GenerateOnboardingReportInput!) {
    generateOnboardingReport(input: $input) {
      asset {
        type
        url
        contentType
        source
        hash
        stepId
        stepType
      }
    }
  }
` as any;
